export const environment = {
  production: true,
  config: '/assets/config.json',
  client_id: 'customer-portal',
  envName: 'production'
};
